import React from "react";
import { format } from "date-fns";

interface DateRange {
  startDate: Date;
  endDate: Date;
}

interface DateRangePickerProps {
  value: DateRange;
  onChange: (range: DateRange) => void;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ value, onChange }) => {
  const handleChange = (key: "startDate" | "endDate", dateStr: string) => {
    const newDate = new Date(dateStr);
    onChange({ ...value, [key]: newDate });
  };

  return (
    <div className="flex flex-wrap items-center gap-4 mb-4">
      {/* Start Date */}
      <div className="flex flex-col">
        <label htmlFor="start-date" className="text-sm font-medium text-muted-foreground">
          From
        </label>
        <input
          id="start-date"
          type="date"
          value={format(value.startDate, "yyyy-MM-dd")}
          onChange={(e) => handleChange("startDate", e.target.value)}
          className="border rounded px-3 py-1 text-sm focus:outline-none focus:ring focus:border-blue-400"
        />
      </div>

      {/* End Date */}
      <div className="flex flex-col">
        <label htmlFor="end-date" className="text-sm font-medium text-muted-foreground">
          To
        </label>
        <input
          id="end-date"
          type="date"
          value={format(value.endDate, "yyyy-MM-dd")}
          onChange={(e) => handleChange("endDate", e.target.value)}
          className="border rounded px-3 py-1 text-sm focus:outline-none focus:ring focus:border-blue-400"
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
